<template>
  <commonTable
    ref="commonTable"
    url="/admin/coupon_batches/coupons"
    reqMethod="GET"
    :column="column"
    :searchColumn="searchColumn"
    limitKey="per_page"
    :advancedSearchColumn="advancedSearchColumn"
    :key="batch_id"
    :extraParams="{ batch_id }"
  >
  </commonTable>
</template>

<script>
import commonTable from '@/component/commonTable.vue'
export default {
  name: 'voucherCheck',
  data () {
    return {
      advancedSearchColumn: [
        {
          label: "面值/折扣",
          prop: "value",
          type: "input",
        },
        {
          label: "类型",
          prop: "type",
          type: "select",
          option: [
            {
              value: 0,
              label: '现金券'
            },
            {
              value: 1,
              label: '折扣券'
            },
          ]
        },
        {
          label: "使用时间起+使用时间止",
          prop: "used_from+used_to",
          type: "date",
          timerange: []
        },
      ],
    }
  },
  props: {
    batch_id: {
      type: Number,
      required: true
    },
    gamesList: {
      type: Array,
      required: true
    }
  },
  computed: {
    text () {
      return this.isEdit !== '' ? '编辑' : '新增'
    },
    column () {
      return [
        {
          label: "代金券ID",
          prop: "batch.id",
          fixed: true
        },
        {
          label: "批次名称",
          prop: "batch.name",
          fixed: true
        },
        {
          label: "面值/折扣",
          prop: "batch.value"
        },
        {
          label: "有效期",
          prop: "batch.valid_date",
          formatter: (row) => {
            let result = ''
            if (row && row.batch) {
              const { valid_at, invalid_at } = row.batch
              if (valid_at) result += valid_at + ' ~ '
              if (invalid_at) result += invalid_at
            }
            return result || '--'
          }
        },
        {
          label: "适用游戏",
          prop: "batch.game_id",
          formatter: (row, column, cellValue) => {
            const findItem = this.gamesList && this.gamesList.find(item => item.value === Number(cellValue))
            return findItem ? findItem.label : cellValue
          }
        },
        {
          label: "满减额度",
          prop: "batch.amount",
        },
        {
          label: "类型",
          prop: "batch.type",
          formatter: (row, column, cellValue) => {
            const findItem = [
              {
                value: 0,
                label: '现金券'
              },
              {
                value: 1,
                label: '折扣券'
              },
            ].find(item => item.value === Number(cellValue))
            return findItem ? findItem.label : cellValue
          }
        },
        {
          label: "用户ID",
          prop: "user_id",
        },
        {
          label: "状态",
          prop: "status",
          formatter: (row, column, cellValue) => {
            const findItem = [
              {
                value: 0,
                label: '未使用'
              },
              {
                value: 1,
                label: '已使用'
              }
            ].find(item => item.value === Number(cellValue))
            return findItem ? findItem.label : cellValue
          }
        },
        {
          label: "使用时间",
          prop: "used_at",
        },
      ]
    },
    searchColumn () {
      return [
        {
          label: "批次名称",
          prop: "name",
          type: "input",
        },
        {
          label: "适用游戏",
          prop: "game_id",
          type: "select",
          option: this.gamesList
        },
        {
          label: "状态",
          prop: "status",
          type: "select",
          option: [
            {
              value: 0,
              label: '未使用'
            },
            {
              value: 1,
              label: '已使用'
            }
          ]
        },
        {
          label: "有效时间起+有效时间止",
          prop: "valid_from+valid_to",
          type: "date",
          timerange: []
        },
      ]
    }
  },
  components: {
    commonTable
  }
}
</script>

<style lang="less" scoped>

</style>
